import { TranslateService } from '@ngx-translate/core';

export class GenderUtils {
  translateService: TranslateService;

  constructor(translateService: TranslateService) {
    this.translateService = translateService;
  }

  private static readonly GENDERS: {
    [key: number]: { id: number; name: string };
  } = {
    1: { id: 1, name: 'Erkek' },
    2: { id: 2, name: 'Kadın' }
  };

  static getGender(id: number): { id: number; name: string } | undefined {
    return this.GENDERS[id];
  }

  static getGenderName(id: number): string {
    return this.GENDERS[id]?.name || 'Unknown';
  }

  static getGenderId(name: string): number | undefined {
    const gender = Object.values(this.GENDERS).find(
      (g) => g.name.toLowerCase() === name.toLowerCase()
    );
    return gender ? gender.id : undefined;
  }

  static getAllGenders(): Array<{ id: number; name: string }> {
    return Object.values(this.GENDERS);
  }
}
